// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('projectActivityType', {
//         templateUrl: 'views/components/views/projectActivityType/projectActivityType.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'projectActivityTypeService', function ($stateParams, stateService, translateService, modalService, projectActivityTypeService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let projectActivityTypeKeyno = $stateParams.projectactivitytype_keyno;

//             let translations = {
//                 error: '',
//                 ok: ''
//             };

//             vm.model = {
//                 edit: {},
//                 lockedSave: false
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATION FUNCTION

//             async function translate() {
//                 let data = await translateService.translateBatch(translations);

//                 Object.keys(translations).forEach((key) => {
//                     if (data?.[key]) translations[key] = data[key];
//                 });
//             }

//             // #endregion TRANSLATION FUNCTION

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadEdit() {
//                 vm.model.edit = (await projectActivityTypeService.getProjectActivityType({ projectactivitytype_keyno: projectActivityTypeKeyno }))[0];
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//             vm.saveChanges = function () {
//                 vm.model.lockedSave = true;

//                 projectActivityTypeService.saveObj(vm.model.edit).then(function (response) {
//                     if (response[0].errorcode !== '0') {
//                     	modalService.show({
//                     		type: 'warning',
//                     		title: translations.error,
//                     		message: response[0].errormessage,
//                     		buttons: [{
//                     			label: translations.ok,
//                     			cssClass: 'btn-warning',
//                     			action: function (dialogItself) {
//                     				dialogItself.close();
//                     				vm.model.lockedSave = false;
//                     			}
//                     		}]
//                     	});
//                     } else {
//                     	vm.model.lockedSave = false;
//                     	stateService.back();
//                     }
//                 });
//             }

//             // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 translate();
//                 loadEdit();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
